const confettiCannon = async (
  origin: { x: number; y: number },
  options: {
    particleCount?: number;
    startVelocity?: number;
  } = {}
) => {
  const confetti = (await import('canvas-confetti')).default;

  const confettiCanvas = document.createElement('canvas');
  confettiCanvas.style.pointerEvents = 'none';
  confettiCanvas.style.position = 'fixed';
  confettiCanvas.style.left = '0';
  confettiCanvas.style.top = '0';
  confettiCanvas.style.right = '0';
  confettiCanvas.style.bottom = '0';
  confettiCanvas.style.width = '100%';
  confettiCanvas.style.height = '100%';
  confettiCanvas.style.zIndex = '9999';
  document.body.appendChild(confettiCanvas);

  const mc = confetti.create(confettiCanvas, {
    resize: true,
    useWorker: true,
  });
  mc({
    particleCount: options.particleCount ?? 100,
    spread: 80,
    startVelocity: options.startVelocity ?? 20,
    gravity: 2,
    origin,
  })?.then(() => {
    document.body.removeChild(confettiCanvas);
  });
};

export default confettiCannon;
